interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

/** Hero mockup — the LCP element. Kept in sync with components/Hero.tsx. */
export const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/8CHHMxsjG8uTN596kv5bDs/MOCKUP.png'

const META_TAGS: MetaTag[] = [
  { name: 'facebook-domain-verification', content: 'vlgvuhfbincjf8k22klsbsto3ag0az' },
]

const LINK_TAGS: LinkTag[] = [
  // Warm up the font + image origins before the CSS/image requests are made.
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: 'https://cdn.magicpatterns.com' },
  // Discover the LCP image as early as possible, at high priority.
  { rel: 'preload', href: HERO_IMAGE_URL, as: 'image', fetchPriority: 'high' },
]

/**
 * Inserts global <meta> and resource-hint <link> tags into <head> once.
 * Existing tags are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
